module.exports = __webpack_public_path__ + "pcclient/img/emergency.e7eb495b.png";